module.exports = __webpack_public_path__ + "img/Progress-Report-Process-6.ae5a34e0.png";